import { render, staticRenderFns } from "./RenewCredentialsCard.vue?vue&type=template&id=90d94ed2&scoped=true&"
import script from "./RenewCredentialsCard.vue?vue&type=script&lang=js&"
export * from "./RenewCredentialsCard.vue?vue&type=script&lang=js&"
import style0 from "./RenewCredentialsCard.vue?vue&type=style&index=0&id=90d94ed2&lang=scss&scoped=true&"
import style1 from "./RenewCredentialsCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d94ed2",
  null
  
)

export default component.exports